/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Update_LoadingInputs */

const en_shipping_update_loading = /** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating shipment info...`)
};

const es_shipping_update_loading = /** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizando información de envío...`)
};

const fr_shipping_update_loading = /** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise à jour des infos d'expédition...`)
};

const de_shipping_update_loading = /** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versandinformationen werden aktualisiert...`)
};

const id_shipping_update_loading = /** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memperbarui info pengiriman...`)
};

/** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */
const ja_shipping_update_loading = en_shipping_update_loading;

/** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */
const zh_shipping_update_loading = en_shipping_update_loading;

/** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */
const ar_shipping_update_loading = en_shipping_update_loading;

/** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */
const it_shipping_update_loading = en_shipping_update_loading;

/** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */
const ru_shipping_update_loading = en_shipping_update_loading;

/** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */
const pt_shipping_update_loading = en_shipping_update_loading;

/** @type {(inputs: Shipping_Update_LoadingInputs) => LocalizedString} */
const ko_shipping_update_loading = en_shipping_update_loading;

/**
* | output |
* | --- |
* | "Updating shipment info..." |
*
* @param {Shipping_Update_LoadingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_update_loading = /** @type {((inputs?: Shipping_Update_LoadingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Update_LoadingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_update_loading(inputs)
	if (locale === "es") return es_shipping_update_loading(inputs)
	if (locale === "fr") return fr_shipping_update_loading(inputs)
	if (locale === "de") return de_shipping_update_loading(inputs)
	if (locale === "ja") return ja_shipping_update_loading(inputs)
	if (locale === "zh") return zh_shipping_update_loading(inputs)
	if (locale === "ar") return ar_shipping_update_loading(inputs)
	if (locale === "id") return id_shipping_update_loading(inputs)
	if (locale === "it") return it_shipping_update_loading(inputs)
	if (locale === "ru") return ru_shipping_update_loading(inputs)
	if (locale === "pt") return pt_shipping_update_loading(inputs)
	return ko_shipping_update_loading(inputs)
});